// removed by extract-text-webpack-plugin
module.exports = {"ios-container":"second-step__ios-container__1Fkar","second-step-container":"second-step__second-step-container__1jYOM","image-view":"second-step__image-view__kPJuc","image-wrapper":"second-step__image-wrapper__1RfZ0","button-wrapper":"second-step__button-wrapper__3mram","remove-image-button":"second-step__remove-image-button__3sJf0","button-inner":"second-step__button-inner__29mNC","hide-mobile":"second-step__hide-mobile__7fenN"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/event/CreateEvent/SecondStep/second-step.scss
// module id = 1529
// module chunks = 1